import { MutationTree } from 'vuex';
import store from '@/store/store';
import { Error } from '@/store/types';
import { DataUser, User, UserState } from './types';

export const mutations: MutationTree<UserState> = {
  USER_SUCCESS: (state, payload: DataUser[]) => {
    state.dataUser = new Array<DataUser>();
    let arrayFilter = payload.sort((a: any, b: any): any => {
      return a.email.localeCompare(b.email);
    });
    arrayFilter.map((value: User, key: number) => {
      state.dataUser!.push(DataUser.fromJSON(value));
    });
  },
  USER_ERROR: (state, payload: Error) => {
    state.dataUser = undefined;
    store.commit('alert/SHOW', {
      prefix: 'USER_ERROR_',
      error: payload.status,
    });
  },
  USER_ADD_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'USER_ADD_ERROR_',
      error: payload.status,
    });
  },
  USER_PUT: (state, payload) => {
    if (state.dataUser) {
      for (let i = 0; i < state.dataUser.length; i++) {
        if (payload._id === state.dataUser[i]._id) {
          state.dataUser[i].regions!.push(payload.select);
        } else if (state.dataUser[i]._id === undefined) {
          state.dataUser[i].regions.push(payload);
        }
      }
    }
  },
  USER_PUT_ERROR: (state, payload: Error) => {
    store.commit('alert/SHOW', {
      prefix: 'USER_PUT_ERROR_',
      error: payload.status,
    });
  },
  USER_DELETE_ERROR: (state, payload: Error) => {
    state.dataUser = undefined;
    store.commit('alert/SHOW', {
      prefix: 'USER_DELETE_ERROR_',
      error: payload.status,
    });
  },
  USER_REGION_CREATE: (state) => {
    if (state.dataUser && state.dataUser.length === 0) {
      state.dataUser.push(new DataUser());
    } else if (
      state.dataUser &&
      state.dataUser.length !== 0 &&
      state.dataUser[state.dataUser.length - 1]._id &&
      state.dataUser[state.dataUser.length - 1]._id !== undefined
    ) {
      state.dataUser.push(new DataUser());
    }
  },
  USER_REGION_DELETE: (state, payload) => {
    if (state.dataUser) {
      for (let i = 0; i < state.dataUser.length; i++) {
        if (payload._id === state.dataUser[i]._id) {
          state.dataUser[i].regions!.splice(payload.index, 1);
        }
      }
    }
  },
};
